import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Container, useToast } from "@chakra-ui/react";
import { useMutation } from "@tanstack/react-query";
import { ResStatus } from "lib/api/enum";
import { callExternalTokenApi } from "../Reservation/api";
import queryString from "query-string";
import usePathNavigate from "lib/hook/usePathNavigate";

function ExternalSign() {
    const { pathNavigate } = usePathNavigate();
    const location = useLocation();
    const toast = useToast();
    const query = queryString.parse(location.search);

    const [loaded, setLoaded] = useState(false);

    const { mutate: externalTokenMutate } = useMutation(callExternalTokenApi, {
        onSuccess: (data) => {
            console.log("externalTokenMutate : ", data);

            if (data.status === ResStatus.RES_SUCCESS) {
                if (data.command.sign_info.link_code === "order_1") {
                    pathNavigate(
                        `/external_sign/reservation/pickup/${data.command.sign_info.order_id}`
                    );
                } else if (data.command.sign_info.link_code === "order_6") {
                    pathNavigate(
                        `/external_sign/reservation/delivery/${data.command.sign_info.order_id}`
                    );
                }
                setLoaded(true);
            } else {
                toast({
                    title: "오류",
                    description: data.result_message,
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                    position: "top",
                });
            }
        },
        onError: (error: any) => {
            console.log("onError : ", error);
            toast({
                title: "오류",
                description: error.message,
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "top",
            });
        },
    });

    useEffect(() => {
        if (query.t) {
            externalTokenMutate({
                external_token: query.t.toString(),
            });
        }
    }, []);

    return (
        <Container
            maxW={"768px"}
            minW={"320px"}
            w={"100%"}
            height={"100vh"}
            px={0}
            bg="white"
        >
            {loaded && <Outlet />}
        </Container>
    );
}

export default ExternalSign;
